// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2YcRe","label":"LabeledBox_label__3wG6h"};